import React from 'react';
import classnames from 'classnames';
import { Link } from 'gatsby';
import * as styles from './item.module.scss';

const Item = ({ ItemData }) => {
  return (
    <Link to={ItemData.href} className={classnames(styles.item, 'cr-sub')}>
      {ItemData.text}
    </Link>
  );
};

export default Item;
